import { loadView, loadView_G, routerCheck } from '@GUTIL/routerPublic'
import LoginRouter from '@G/router/login'
import ErrorRouter from '@G/router/error'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解決重複push到同一個url會報錯的問題
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: loadView_G('GlobalLayout', 'Layout'),
      children: [
        {
          path: '/',
          name: 'Home',
          component: loadView('Home')
        },
        {
          path: '/Order',
          name: 'Order',
          component: loadView('index', 'Order'),
          children: [
            {
              path: 'List',
              name: 'Order.List',
              component: loadView('List', 'Order')
            },
            {
              path: 'New',
              name: 'Order.Create',
              component: loadView('New', 'Order')
            },
            {
              path: 'Resend',
              name: 'Order.Resend',
              component: loadView('Resend', 'Order')
            }
          ]
        },
        {
          path: '/Report',
          name: 'Report',
          component: loadView('index', 'Report'),
          children: [
            {
              path: 'List',
              name: 'Report.List',
              component: loadView('List', 'Report')
            }
          ]
        }
      ]
    },
    ...LoginRouter,
    ...ErrorRouter
  ]
})

router.beforeEach(routerCheck)

export default router
